(() => {
  class BuyTogether extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-bt-item]'));
      this.submitButton = this.querySelector('[data-bt-submit]');
      this.totalEl = this.querySelector('[data-bt-total]');
      this.compareEl = this.querySelector('[data-bt-compare]');
      this.countEl = this.querySelector('[data-bt-count]');
      this.errorEl = this.querySelector('[data-bt-error]');
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: this.dataset.currency || 'BRL',
      });

      this.addEventListener('change', (event) => {
        if (event.target.matches('[data-bt-checkbox]')) this.update();
      });
      this.submitButton.addEventListener('click', () => this.addToCart());

      this.update();
    }

    get selectedItems() {
      return this.items.filter((item) => item.querySelector('[data-bt-checkbox]').checked);
    }

    format(cents) {
      return this.formatter.format(cents / 100);
    }

    update() {
      const selected = this.selectedItems;
      const total = selected.reduce((sum, item) => sum + Number(item.dataset.price), 0);
      const compare = selected.reduce((sum, item) => sum + Number(item.dataset.comparePrice), 0);

      this.items.forEach((item) => {
        const checked = selected.includes(item);
        item.classList.toggle('tp-buy-together__card--off', !checked);
      });

      this.totalEl.textContent = this.format(total);
      this.compareEl.textContent = this.format(compare);
      this.compareEl.hidden = compare <= total;
      this.countEl.textContent = selected.length === 1 ? '1 item' : `${selected.length} itens`;
      this.submitButton.disabled = selected.length === 0;
    }

    async addToCart() {
      const selected = this.selectedItems;
      if (!selected.length || this.submitButton.getAttribute('aria-busy') === 'true') return;

      const body = {
        items: selected.map((item) => ({ id: Number(item.dataset.variantId), quantity: 1 })),
      };
      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        body.sections = this.cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      this.submitButton.setAttribute('aria-busy', 'true');
      this.errorEl.textContent = '';

      try {
        const response = await fetch(`${window.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          this.errorEl.textContent = data.description || data.message || '';
          return;
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'buy-together', cartData: data });
        }

        if (this.cart && typeof this.cart.renderContents === 'function' && data.sections) {
          this.cart.classList.remove('is-empty');
          this.cart.renderContents(data);
        } else {
          window.location.href = window.routes.cart_url;
        }
      } catch (error) {
        this.errorEl.textContent = 'Não foi possível adicionar ao carrinho. Tente novamente.';
      } finally {
        this.submitButton.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('tp-buy-together')) customElements.define('tp-buy-together', BuyTogether);
})();
